import React from 'react';
import axios from 'axios';
import { Pie } from "react-chartjs-2";

class UsersOverview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      users: [],
      loaded: false
    }

  }

  componentDidMount() {
    if (this.props.sessionData && this.props.sessionData.accessToken) {
      this.getUsers();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.sessionData && nextProps.sessionData.accessToken && nextProps.active && !this.state.loaded) {
      this.getUsers();
    }
  }

  getUsers() {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      }
    };
    axios.get(this.props.api.users, config)
      .then((response) => {
        this.setState({
          users: response.data
        })
      }).catch((error) => {
      console.log("Axios error: ", error);
    });
  }

  render() {
    return (
      <div id="usersStats-page">
        <ActiveUsers {...this.props} allUsers={this.state.users} />
        <UsersByGender {...this.props} allUsers={this.state.users} />
        <UsersByYearKm {...this.props} allUsers={this.state.users} />
        <UsersByDLObtained {...this.props} allUsers={this.state.users} />
        <UsersByDLGroups {...this.props} allUsers={this.state.users} />
        <UsersByRegion {...this.props} allUsers={this.state.users} />
      </div>
    );
  }
}

class ActiveUsers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      from: null,
      to: null,
      activeUsers: []
    }
  }

  componentDidMount() {
    if (this.props.sessionData.accessToken)
      this.getActiveUsers();
  }

  getActiveUsers() {
    let loginToken = this.props.sessionData.accessToken;
    let config = {
      headers: {
        'Authorization': 'Bearer ' + loginToken
      },
      params: {
        from: this.state.from,
        to: this.state.to
      }
    };
    axios.get(this.props.api.stats.activeUsers, config)
      .then((response) => {
        this.setState({
          activeUsers: response.data
        });
      }).catch((error) => {
      console.log("Axios error: ", error);
    });
  }

  render() {
    const chartData = {
      'labels': ['Neaktivní uživatelé', 'Aktivní uživatelé'],
      'datasets': [
        {
          data: [
            this.props.allUsers.length - this.state.activeUsers.length,
            this.state.activeUsers.length
          ],
          backgroundColor: ['#9CC2CB', '#1ABB9C']
        }
      ]
    };
    const chartOptions = {
      responsive: true,
      title: {
        display: false,
      },
      legend: {
        display: false
      }
    };

    return (
      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <div className="x-panel">
          <div className="x-title">
            <h2>Uživatelé podle aktivity</h2>
            <div className="clearfix" />
          </div>
          <div className="x-content">
            <div className="col-xs-12 col-sm-6">
              <h5 className="graph-title">Graf</h5>
              <Pie data={chartData} options={chartOptions} />
            </div>
            <div className="col-xs-12 col-sm-6">
              <table className="tile-info">
                <thead>
                <tr>
                  <th>Uživatelé</th>
                  <th>Počet</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <p><i className="fa fa-square green" />Aktivní</p>
                  </td>
                  <td>{this.state.activeUsers.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square aero" />Neaktivní</p>
                  </td>
                  <td>{this.props.allUsers.length - this.state.activeUsers.length}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class UsersByGender extends React.Component {
  render() {

    const males = this.props.allUsers.filter((user) => user.gender === 'M').length;
    const females = this.props.allUsers.filter((user) => user.gender === 'F').length;
    const others = this.props.allUsers.filter((user) => user.gender !== 'F' && user.gender !== 'M').length;

    const chartData = {
      'labels': ['Muž', 'Žena', 'Nezadáno'],
      'datasets': [
        {
          data: [males, females, others],
          backgroundColor: ['#3498DB', '#E74C3C', '#9CC2CB']
        }
      ]
    };
    const chartOptions = {
      responsive: true,
      title: {
        display: false,
      },
      legend: {
        display: false
      }
    };

    return (
      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <div className="x-panel">
          <div className="x-title">
            <h2>Uživatelé podle pohlaví</h2>
            <div className="clearfix" />
          </div>
          <div className="x-content">
            <div className="col-xs-12 col-sm-6">
              <h5 className="graph-title">Graf</h5>
              <Pie data={chartData} options={chartOptions} />
            </div>
            <div className="col-xs-12 col-sm-6">
              <table className="tile-info">
                <thead>
                <tr>
                  <th>Pohlaví</th>
                  <th>Počet</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <p><i className="fa fa-square blue" />Muž</p>
                  </td>
                  <td>{males}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square red" />Žena</p>
                  </td>
                  <td>{females}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square aero" />Nezadáno</p>
                  </td>
                  <td>{others}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class UsersByRegion extends React.Component {
  render() {
    const chartData = {
      'labels': [],
      'datasets': [
        {
          data: [],
          backgroundColor: []
        }
      ]
    };
    const chartOptions = {
      responsive: true,
      title: {
        display: false,
      },
      legend: {
        display: false
      }
    };

    const groupByRegion = (arrayOfUsers) => {
      const usersByRegion = { 'Nezadáno': [] };
      arrayOfUsers.forEach((user) => {
        if (user.address && user.address.region) {
          if (!usersByRegion[user.address.region]) usersByRegion[user.address.region] = [];
          usersByRegion[user.address.region].push(user);
        } else {
          usersByRegion['Nezadáno'].push(user);
        }
      });
      return usersByRegion;
    };

    const { allUsers } = this.props;
    let regionsUsers = [];
    let regions = [];
    if (allUsers.length > 0) {
      regionsUsers = groupByRegion(this.props.allUsers);
      for (let region in regionsUsers) {
        if (regionsUsers.hasOwnProperty(region))
          regions.push({ name: region, users: regionsUsers[region] })
      }
    }

    const colors = ['#E09F3E', '#335C67', '#9E2A2B', '#21A179', '#950952', '#3E7CB1', '#9EE493', '#70566D', '#BA6E6E', '#5BC0EB', '#FDE74C', '#9BC53D', '#C3423F']

    const sortedRegions = regions.sort((a, b) => a.users.length < b.users.length ? 1 : a.users.length > b.users.length ? -1 : 0);
    sortedRegions.forEach((region) => {
      chartData.labels.push(region.name);
      chartData.datasets[0].data.push(region.users.length);
      if (region.name === 'Nezadáno') {
        chartData.datasets[0].backgroundColor.push('#9CC2CB');
      } else {
        let index = Math.round(Math.random() * colors.length);
        chartData.datasets[0].backgroundColor.push(colors[index]);
        colors.splice(index, 1);
      }
    });

    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div className="x-panel">
          <div className="x-title">
            <h2>Uživatelé podle kraje</h2>
            <div className="clearfix" />
          </div>
          <div className="x-content">
            <div className="col-xs-12 col-sm-6">
              <h5 className="graph-title">Graf</h5>
              <Pie data={chartData} options={chartOptions} />
            </div>
            <div className="col-xs-12 col-sm-6">
              <table className="tile-info">
                <thead>
                <tr>
                  <th>Kraj</th>
                  <th>Počet</th>
                </tr>
                </thead>
                <tbody>
                {
                  sortedRegions.map((region, index) =>
                    <tr key={`region${index}`}>
                      <td>
                        <p><i className="fa fa-square"
                              style={{ color: chartData.datasets[0].backgroundColor[index] }} />{region.name}</p>
                      </td>
                      <td>{region.users.length}</td>
                    </tr>
                  )
                }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class UsersByYearKm extends React.Component {
  render() {

    const { allUsers } = this.props;

    const to500km = allUsers.filter((user) => user.yearKm === "do 500 km");
    const to1000km = allUsers.filter((user) => user.yearKm === "do 1000 km");
    const to3000km = allUsers.filter((user) => user.yearKm === "do 3000 km");
    const above3000km = allUsers.filter((user) => user.yearKm === "nad 3000 km");
    const others = allUsers.filter((user) => user.yearKm !== "do 500 km" && user.yearKm !== "do 1000 km" && user.yearKm !== "do 3000 km" && user.yearKm !== "nad 3000 km");

    const chartData = {
      'labels': ['do 500 km', 'do 1000 km', 'do 3000 km', 'nad 3000 km', 'Nezadáno'],
      'datasets': [
        {
          data: [to500km.length, to1000km.length, to3000km.length, above3000km.length, others.length],
          backgroundColor: ['#3498DB', '#9B59B6', '#1ABB9C', '#E74C3C', '#9CC2CB']
        }
      ]
    };
    const chartOptions = {
      responsive: true,
      title: {
        display: false,
      },
      legend: {
        display: false
      }
    };

    return (
      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <div className="x-panel">
          <div className="x-title">
            <h2>Uživatelé podle ročně najetých kilometrů</h2>
            <div className="clearfix" />
          </div>
          <div className="x-content">
            <div className="col-xs-12 col-sm-6">
              <h5 className="graph-title">Graf</h5>
              <Pie data={chartData} options={chartOptions} />
            </div>
            <div className="col-xs-12 col-sm-6">
              <table className="tile-info">
                <thead>
                <tr>
                  <th>Km ročně</th>
                  <th>Počet</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <p><i className="fa fa-square blue" />do 500 km</p>
                  </td>
                  <td>{to500km.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square purple" />do 1000 km</p>
                  </td>
                  <td>{to1000km.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square green" />do 3000 km</p>
                  </td>
                  <td>{to3000km.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square red" />nad 3000 km</p>
                  </td>
                  <td>{above3000km.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square aero" />Nezadáno</p>
                  </td>
                  <td>{others.length}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class UsersByDLObtained extends React.Component {
  render() {

    const { allUsers } = this.props;

    const to1year = allUsers.filter((user) => user.yearDLObtained === "do 1 roku");
    const to10years = allUsers.filter((user) => user.yearDLObtained === "do 10 let");
    const above10years = allUsers.filter((user) => user.yearDLObtained === "nad 10 let");
    const others = allUsers.filter((user) => user.yearDLObtained !== "do 1 roku" && user.yearDLObtained !== "do 10 let" && user.yearDLObtained !== "nad 10 let");

    const chartData = {
      'labels': ['Do 1 roku', 'Do 10 let', 'Nad 10 let', 'Nezadáno'],
      'datasets': [
        {
          data: [to1year.length, to10years.length, above10years.length, others.length],
          backgroundColor: ['#3498DB', '#9B59B6', '#E74C3C', '#9CC2CB']
        }
      ]
    };
    const chartOptions = {
      responsive: true,
      title: {
        display: false,
      },
      legend: {
        display: false
      }
    };

    return (
      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <div className="x-panel">
          <div className="x-title">
            <h2>Uživatelé podle délky trvání řidičského oprávnění</h2>
            <div className="clearfix" />
          </div>
          <div className="x-content">
            <div className="col-xs-12 col-sm-6">
              <h5 className="graph-title">Graf</h5>
              <Pie data={chartData} options={chartOptions} />
            </div>
            <div className="col-xs-12 col-sm-6">
              <table className="tile-info">
                <thead>
                <tr>
                  <th>Délka trvání</th>
                  <th>Počet</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <p><i className="fa fa-square blue" />do 1 roku</p>
                  </td>
                  <td>{to1year.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square purple" />do 10 let</p>
                  </td>
                  <td>{to10years.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square red" />nad 10 let</p>
                  </td>
                  <td>{above10years.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square aero" />Nezadáno</p>
                  </td>
                  <td>{others.length}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class UsersByDLGroups extends React.Component {
  render() {

    const { allUsers } = this.props;
    let AM = [], A1 = [], A2 = [], A = [], B1 = [], B = [], BE = [], C1 = [], C1E = [], C = [], CE = [], D1 = [],
      D1E = [], D = [], DE = [], T = [], others = [];
    if (allUsers.length > 0) {
      AM = allUsers.filter((user) => user.dlGroups && user.dlGroups.indexOf('AM') > -1);
      A1 = allUsers.filter((user) => user.dlGroups && user.dlGroups.indexOf('A1') > -1);
      A2 = allUsers.filter((user) => user.dlGroups && user.dlGroups.indexOf('A2') > -1);
      A = allUsers.filter((user) => user.dlGroups && user.dlGroups.indexOf('A') > -1);
      B1 = allUsers.filter((user) => user.dlGroups && user.dlGroups.indexOf('B1') > -1);
      B = allUsers.filter((user) => user.dlGroups && user.dlGroups.indexOf('B') > -1);
      BE = allUsers.filter((user) => user.dlGroups && user.dlGroups.indexOf('B+E') > -1);
      C1 = allUsers.filter((user) => user.dlGroups && user.dlGroups.indexOf('C1') > -1);
      C1E = allUsers.filter((user) => user.dlGroups && user.dlGroups.indexOf('C1+E') > -1);
      C = allUsers.filter((user) => user.dlGroups && user.dlGroups.indexOf('C') > -1);
      CE = allUsers.filter((user) => user.dlGroups && user.dlGroups.indexOf('C+E') > -1);
      D1 = allUsers.filter((user) => user.dlGroups && user.dlGroups.indexOf('D1') > -1);
      D1E = allUsers.filter((user) => user.dlGroups && user.dlGroups.indexOf('D1+E') > -1);
      D = allUsers.filter((user) => user.dlGroups && user.dlGroups.indexOf('D') > -1);
      DE = allUsers.filter((user) => user.dlGroups && user.dlGroups.indexOf('D+E') > -1);
      T = allUsers.filter((user) => user.dlGroups && user.dlGroups.indexOf('T') > -1);
      others = allUsers.filter((user) => user.dlGroups === undefined || user.dlGroups.length === 0);
    }

    const chartData = {
      'labels': ['AM', 'A1', 'A2', 'A', 'B1', 'B', 'B+E', 'C1', 'C1+E', 'C', 'C+E', 'D1', 'D1+E', 'D', 'D+E', 'T', 'Nezadáno'],
      'datasets': [
        {
          data: [AM.length, A1.length, A2.length, A.length, B1.length, B.length, BE.length, C1.length, C1E.length, C.length, CE.length, D1.length, D1E.length, D.length, DE.length, T.length, others.length],
          backgroundColor: ['#758E4F', '#86BBD8', '#339989', '#E09F3E', '#335C67', '#9E2A2B', '#21A179', '#950952', '#3E7CB1', '#9EE493', '#70566D', '#BA6E6E', '#5BC0EB', '#FDE74C', '#9BC53D', '#C3423F', '#9CC2CB']
        }
      ]
    };
    const chartOptions = {
      responsive: true,
      title: {
        display: false,
      },
      legend: {
        display: false
      }
    };

    return (
      <div className="col-xs-12 col-sm-12col-md-12 col-lg-12">
        <div className="x-panel">
          <div className="x-title">
            <h2>Uživatelé podle skupiny řidčského oprávnění</h2>
            <div className="clearfix" />
          </div>
          <div className="x-content">
            <div className="col-xs-12 col-sm-6">
              <h5 className="graph-title">Graf</h5>
              <Pie data={chartData} options={chartOptions} />
            </div>
            <div className="col-xs-12 col-sm-6">
              <table className="tile-info">
                <thead>
                <tr>
                  <th>Skupina</th>
                  <th>Počet</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <p><i className="fa fa-square" style={{ color: '#758E4F' }} />AM</p>
                  </td>
                  <td>{AM.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square" style={{ color: '#86BBD8' }} />A1</p>
                  </td>
                  <td>{A1.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square" style={{ color: '#339989' }} />A2</p>
                  </td>
                  <td>{A2.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square" style={{ color: '#E09F3E' }} />A</p>
                  </td>
                  <td>{A.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square" style={{ color: '#335C67' }} />B1</p>
                  </td>
                  <td>{B1.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square" style={{ color: '#9E2A2B' }} />B</p>
                  </td>
                  <td>{B.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square" style={{ color: '#21A179' }} />B+E</p>
                  </td>
                  <td>{BE.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square" style={{ color: '#950952' }} />C1</p>
                  </td>
                  <td>{C1.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square" style={{ color: '#3E7CB1' }} />C1+E</p>
                  </td>
                  <td>{C1E.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square" style={{ color: '#9EE493' }} />C</p>
                  </td>
                  <td>{C.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square" style={{ color: '#70566D' }} />C+E</p>
                  </td>
                  <td>{CE.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square" style={{ color: '#BA6E6E' }} />D1</p>
                  </td>
                  <td>{D1.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square" style={{ color: '#5BC0EB' }} />D1+E</p>
                  </td>
                  <td>{D1E.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square" style={{ color: '#FDE74C' }} />D</p>
                  </td>
                  <td>{D.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square" style={{ color: '#9BC53D' }} />D+E</p>
                  </td>
                  <td>{DE.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square" style={{ color: '#C3423F' }} />T</p>
                  </td>
                  <td>{T.length}</td>
                </tr>
                <tr>
                  <td>
                    <p><i className="fa fa-square" style={{ color: '#9CC2CB' }} />Nezadáno</p>
                  </td>
                  <td>{others.length}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UsersOverview;



/** WEBPACK FOOTER **
 ** ./src/containers/Statistics/usersOverview.js
 **/